import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { SimpleFilter } from '../../models/simple-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { ManufacturerAuction } from '../../models/manufacturer-auction';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-detail-manufacturer',
  templateUrl: './home-main-modal-detail-manufacturer.component.html',
  styleUrls: ['./home-main-modal-detail-manufacturer.component.sass']
})
export class HomeMainModalDetailManufacturerComponent implements OnInit, AfterViewInit {


  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @Output() manufacturerSelected = new EventEmitter<any>();

  dt: DataTables.Api;
  modelManufacturerFilter: SimpleFilter = new SimpleFilter();
  modelManufacturerAuction: ManufacturerAuction = new ManufacturerAuction();
  dtOptionsManufacturers: DataTables.Settings = {};
  dataSetManufacturers: any;
  selectedRow: number;
  private opened = false;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) { }

  ngOnInit() {

    const that = this;

    $('#modalDetailManufacturer').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });
    
    this.dtOptionsManufacturers = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.Name = this.modelManufacturerFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer}/manufacturer`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetManufacturers = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [
        { orderable: false },
        { data: 'manufactName', name: 'manufactName' },
      ]
    };

  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  onSelectManufacturer(manufacturer: string): void {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturer', null, 'Select manufacturer started');
      
      const item = this.dataSetManufacturers[this.selectedRow];
      this.bus.currentAuction.drugs.filter(c => c.current)[0].manufacturer = item.name;
      let regexp = /^((?!(Гротекс)).)*$/;
      if (item.name != null) {
        if (!regexp.test(item.name))
          this.bus.currentAuction.statusst = 'Выиграли';
        else
          this.bus.currentAuction.statusst = 'Проиграли';
      }
      $('#modalDetailManufacturer').modal('hide');
      const currentDrug = this.bus.currentAuction.drugs.filter(c => c.current)[0];
      this.manufacturerSelected.emit(currentDrug);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturer', null, 'Select manufacturer completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturer', _error, null, 'Select manufacturer failed');
      throw _error;
    }
  }

  onSelectManufacturerRow(index, manufacturer: string): void {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturerRow', null, 'Select manufacturer row started');
      
      this.selectedRow = index;
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturerRow', null, 'Select manufacturer row completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDetailManufacturerComponent.onSelectManufacturerRow', _error, null, 'Select manufacturer row failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail-manufacturer/home-main-modal-detail-manufacturer.component.ts